import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface PropertyBasicInfoProps {
  propertyTitle: string;
  propertyAddress: string;
  setPropertyTitle: (value: string) => void;
  setPropertyAddress: (value: string) => void;
}

export function PropertyBasicInfo({
  propertyTitle,
  propertyAddress,
  setPropertyTitle,
  setPropertyAddress,
}: PropertyBasicInfoProps) {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="propertyTitle">Título do Imóvel</Label>
        <Input
          id="propertyTitle"
          value={propertyTitle}
          onChange={(e) => setPropertyTitle(e.target.value)}
          placeholder="Ex: Apartamento Luxuoso"
        />
      </div>

      <div className="space-y-2">
        <Label htmlFor="propertyAddress">Endereço</Label>
        <Input
          id="propertyAddress"
          value={propertyAddress}
          onChange={(e) => setPropertyAddress(e.target.value)}
          placeholder="Rua, número, bairro, cidade"
        />
      </div>
    </>
  );
}